import PhoneIcon from '@mobi/ds/static/icons/outlined/autoriza-pelo-celular.svg'
import CalendarIcon from '@mobi/ds/static/icons/outlined/calendario.svg'
import ClockIcon from '@mobi/ds/static/icons/outlined/chat-aguardando.svg'
import SmileIcon from '@mobi/ds/static/icons/outlined/sorriso.svg'

import './benefits.scss'

const Benefits = () => {
  const cards = [
    {
      text: 'O dinheiro cai  em até 24h',
      width: '36px',
      height: '36px',
      Icon: ClockIcon
    },
    {
      text: 'Sem descontos ou prestações mensais',
      width: '48px',
      height: '48px',
      Icon: CalendarIcon
    },
    {
      text: 'Conte com o apoio de um time de especialistas',
      width: '46px',
      height: '60px',
      Icon: PhoneIcon
    },
    {
      text: 'Não interfere na contratação de outros empréstimos',
      width: '48px',
      height: '48px',
      Icon: SmileIcon
    }
  ]

  return (
    <div className="benefits">
      <div className="benefits__container">
        <h2 className="benefits__title">
          Vantagens de contratar a antecipação do{' '}
          <span className="--orange">Saque-Aniversário</span>
        </h2>

        <div className="benefits__cards">
          {cards.map(({ width, height, text, Icon }) => {
            return (
              <div key={text} className="benefits__card">
                <div className="benefits__icon-wrapper">
                  <Icon
                    width={width}
                    height={height}
                    className="benefits__icon"
                  />
                </div>

                <p className="benefits__card-text">{text}</p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Benefits
